import React from "react";
import styles from "./AboutUs.module.css"; // Você criará o CSS correspondente

import { TrendingUp, Shield, Lightbulb, UserCheck } from "lucide-react";

const differentials = [
    {
        icon: TrendingUp,
        title: "Aumento da produtividade",
        description:
            "Automatização de processos que reduzem tempo e aumentam a eficiência da sua produção em até 40%.",
        color: "#22c55e"
    },
    {
        icon: Shield,
        title: "Controle total",
        description:
            "Visibilidade completa de todos os processos, custos e prazos. Tome decisões baseadas em dados reais.",
        color: "#3b82f6"
    },
    {
        icon: Lightbulb,
        title: "Inovação constante",
        description:
            "Atualizações regulares com novas funcionalidades baseadas no feedback dos nossos clientes do setor.",
        color: "#facc15"
    },
    {
        icon: UserCheck,
        title: "Suporte dedicado",
        description:
            "Equipe pronta para ajudar você a qualquer momento, garantindo que nada atrapalhe sua operação.",
        color: "#fa15e3"
    }
];

const AboutUs = () => {
    return (
        <section id="about-section" className={styles["about-section"]}>
            <div className={styles["about-header"]}>
                <h2 className={styles["about-title"]}>Nosso Diferencial</h2>
                <p className={styles["about-description"]}>
                    24 anos de experiência no chão de fábrica transformados em soluções
                    tecnológicas que realmente atendem às necessidades do setor têxtil.
                </p>
            </div>

            <div className={styles["about-grid"]}>
                <div className={styles["about-main"]}>
                    <div className={styles["about-cards-right"]}>
                        <h3 className={styles["main-title"]}>Conhecimento do chão de fábrica</h3>
                        <p className={styles["main-description"]}>
                            Nossa experiência de mais de 24 anos trabalhando diretamente no setor têxtil nos permite entender profundamente os desafios reais que você enfrenta no dia a dia.
                        </p>
                        <ul className={styles["main-list"]}>
                            <li>Processos otimizados baseados na prática</li>
                            <li>Soluções testadas em ambiente real</li>
                            <li>Suporte especializado no setor</li>
                        </ul>
                    </div>

                    <div className={styles["about-cards-right"]}>
                        <h3 className={styles["main-title"]}>Tecnologia que ajuda de verdade</h3>
                        <p className={styles["main-description"]}>
                            Soluções práticas para a sua fábrica funcionar melhor, sem complicação.
                        </p>
                        <ul className={styles["main-list"]}>
                            <li>Sistemas fáceis de usar e que se conectam entre si</li>
                            <li>Informações rápidas pra decisões mais certeiras</li>
                            <li>Treinamento simples pra equipe aplicar no dia a dia</li>
                        </ul>
                    </div>

                </div>


                <div className={styles["about-cards"]}>
                    {differentials.map((item, index) => {
                        const Icon = item.icon;
                        return (
                            <div
                                key={item.title}
                                className={styles["differential-card"]}
                                style={{ animationDelay: `${index * 0.1}s` }}
                            >
                                <Icon size={28} color={item.color} />
                                <div className={styles["card-title"]}>{item.title}</div>
                                <div className={styles["card-description"]}>{item.description}</div>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default AboutUs;
